<template>
  <div 
    id="app"
    :class="$route.name"
  >
    <header 
      class="banner"
      :class="{'mobile-sidebar-open': mobileSidebarOpen}"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="tagline">
            <h1 v-if="$route.name == 'home'">{{ this.$store.state.tagline }}</h1>
            <h2 v-else>{{ this.$store.state.tagline }}</h2>
          </div>
          <nav class="nav-primary">
            <div class="menu-primary-navigation-container">
              <ul class="nav">
                <li 
                  class="menu-item nav-item"
                  :class="{'current_page_item': ($route.name == 'about') ? true : false}"
                ><router-link to="/about">About</router-link></li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </header>
    <router-view/>
    <footer class="content-info">
      <p>&copy;{{ new Date().getFullYear() }} UserStock</p>
    </footer>
  </div>
</template>

<script>
export default {
  computed: {
    mobileSidebarOpen: function () {
      return this.$store.state.mobileSidebarOpen
    }
  }
}
</script>

